"use client";

import { faSearch } from "@fortawesome/pro-solid-svg-icons";
import { SquareButton, useModal } from "@tosize/ui";
import { Fragment } from "react";
import { Drop } from "~/components/layout/Header/Drop";
import DropSearch from "~/components/layout/Header/Search/DropSearch";

interface Props {
	lang: string;
	suggestions: { title: string; href: string }[];
	messages: {
		title: string;
		inputTitle: string;
		closeTitle: string;
		suggestionsTitle: string;
		loading: string;
		noResults: string;
	};
}

export function SearchButton(props: Props) {
	const drop = useModal();

	return (
		<Fragment>
			<SquareButton
				title={props.messages.title}
				icon={faSearch}
				component="button"
				color="shades"
				className="xl:hidden"
				onClick={drop.toggle}
			/>

			<Drop open={drop.open} closeAction={drop.close} offsetTop={0}>
				<DropSearch
					lang={props.lang}
					onOpenChange={drop.toggle}
					suggestions={props.suggestions}
					messages={props.messages}
				/>
			</Drop>
		</Fragment>
	);
}
